var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"aria-label":_vm.isFavorited(_vm.item)
      ? _vm.$t('removeFavorite', { name: _vm.item.name })
      : _vm.$t('addAsFavorite', { name: _vm.item.name }),"aria-pressed":_vm.isFavorited(_vm.item) ? 'true' : 'false'},on:{"click":function($event){return _vm.toggle()}}},[_c('font-awesome-icon',{class:_vm.isFavorited(_vm.item) ? 'text-danger' : 'text-muted',attrs:{"icon":'heart'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }